const ReportTypesCard = ({ data, onClick = () => {} }) => {
  if (!data) return null;

  return (
    <div
      className="ccandmocktest-report-header-container"
      onClick={() => onClick(data)}
      style={data?.style}
    >
      <div className="ccandmocktest-report-header-iconandname">
        {data?.svg}
        <div>{data?.name}</div>
      </div>
      <div className="ccandmocktest-report-header-count">
        {data?.count}
      </div>
    </div>
  );
};

export default ReportTypesCard;
